"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureText = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Base_1 = require("./Base");
var StyledFeatureText = (0, styled_components_1.default)(Base_1.Base)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  line-height: 130%;\n"], ["\n  font-family: ", ";\n  line-height: 130%;\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.typography.featureText.fontFamily, ", georgia, serif");
});
/**
 * A variant of our core typography which applies the font-family and line-heights associated with our Feature text style.
 *
 * Accepts the same props as our regular `BodyText` component - see those docs for more info, but note that Feature only comes in a single font weight.
 */
exports.FeatureText = (0, react_1.forwardRef)(function (_a, ref) {
    var sizes = _a.sizes, color = _a.color, className = _a.className, children = _a.children, as = _a.as, props = __rest(_a, ["sizes", "color", "className", "children", "as"]);
    var _b = (0, styled_components_1.useTheme)(), colors = _b.colors, fontSizes = _b.typography.fontSizes;
    return (react_1.default.createElement(StyledFeatureText, __assign({ sizes: (sizes === null || sizes === void 0 ? void 0 : sizes.length)
            ? sizes
            : [
                fontSizes.fontSize28,
                fontSizes.fontSize32,
                fontSizes.fontSize40,
                fontSizes.fontSize48,
            ], color: color !== null && color !== void 0 ? color : colors.text.primary, ref: ref, className: className, forwardedAs: as }, props), children));
});
var templateObject_1;
